var map = {
	"./Alexander the great.jpeg": 2769,
	"./Branwen Tempestoso.jpeg": 8707,
	"./Cador Il Colosso.jpeg": 8375,
	"./Cariatide 2.jpeg": 7331,
	"./Cariatide 3.jpeg": 9596,
	"./Cariatide.jpeg": 3461,
	"./Centurione-removebg-preview.png": 9111,
	"./Cornelia 2.jpeg": 5716,
	"./Cornelia Aelia.jpeg": 4814,
	"./Cornelia.jpeg": 334,
	"./Dimitrios Alexandros.jpeg": 9136,
	"./Dimitrios_Alexandros-removebg-preview.png": 985,
	"./Enigma Pergamo.png": 2084,
	"./Hastut-removebg-preview.png": 2382,
	"./Idra-removebg-preview.png": 9823,
	"./Lysander Nyssa.jpeg": 9075,
	"./Mockingjay-removebg-preview.png": 5497,
	"./Philoctetes.png": 4960,
	"./Porfirione-removebg-preview.png": 3032,
	"./Pugnale_di_dioniso-removebg-preview.png": 3651,
	"./Screenshot 2023-12-12 174511.png": 7628,
	"./Screenshot 2024-01-05 192840.png": 8182,
	"./Screenshot 2024-01-05 192904.png": 1183,
	"./Screenshot 2024-01-05 193330.png": 8823,
	"./Screenshot 2024-01-05 195641.png": 8028,
	"./Screenshot 2024-01-05 195712.png": 6569,
	"./Screenshot 2024-01-05 231415.png": 3182,
	"./Sextus Umbra.jpeg": 4302,
	"./Tempio di Atena.png": 8324,
	"./Toutatis.jpg": 6185,
	"./Zahra heroic.jpeg": 5585,
	"./Zahra.jpeg": 5107,
	"./altare-di-pergamo-frontale.jpg": 4027,
	"./arma & toga page preview.png": 139,
	"./centauro arabo.png": 8332,
	"./centauro romano.png": 7885,
	"./centauro sarmato.png": 1524,
	"./copertina-pergamon.jpg": 7277,
	"./dioscuro.jpeg": 5565,
	"./erinni.png": 8401,
	"./galeforce-rapier.png": 9354,
	"./gypsiadina.jpg": 249,
	"./gypsiadina.png": 3889,
	"./hastatus.jpg": 3829,
	"./kinbane-s-beacon.png": 3769,
	"./mappa europa.png": 8566,
	"./mappa.jpg": 35,
	"./maschera_cavalleria-removebg-preview.png": 5490,
	"./molossus engineer.png": 5376,
	"./molossus mage.png": 437,
	"./molossus woman.png": 3353,
	"./pergamo-removebg-preview.png": 8886,
	"./pergamo.jpg": 1465,
	"./piano-superiore.png": 5630,
	"./piano-terra.png": 4722,
	"./pianta pergamo.jpg": 8554,
	"./pianta-altare.png": 9335,
	"./roman cavalry1.jpeg": 5773,
	"./roman soldier.jpeg": 338,
	"./sea-wardens-shell.png": 3485,
	"./tempio-Asclepio-Apollo.png": 6033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5162;